import { render } from "./ActivityNewbiePage.vue?vue&type=template&id=1cbac16c&scoped=true"
import script from "./ActivityNewbiePage.vue?vue&type=script&lang=js"
export * from "./ActivityNewbiePage.vue?vue&type=script&lang=js"

import "./ActivityNewbiePage.vue?vue&type=style&index=0&id=1cbac16c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbac16c"]])

export default __exports__